import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_DEVICE_PERMISSION = `${API_URL}/api/v1/parent/contact-list`;
export const BLOCK_CHILD_CONTACTS = `${API_URL}/api/v1/parent/block-calling`;

export function childContacts(data) {
    return axiosInstance({
        url: `${GET_DEVICE_PERMISSION}?deviceId=${data.deviceId}${data.searchContact ? `&search=${data.searchContact}` : ''}`,
        method: "GET",
    })
}
export function blockContacts(payload) {
    return axiosInstance({
        url: BLOCK_CHILD_CONTACTS,
        method: "PUT",
        data: payload
    })
}
